
import React, { useContext, Children, useState, useEffect } from 'react'
import { GlobalContext } from '../GlobalContext'
import SignatureCanvas from '../dashboard/SignatureCanvas'
import JsonDebug from '../ui-elements/JsonDebug'
import Button from '../formfields/Button'



type Props = {
    answerPhoto: string | null
    setAnswerPhoto: React.Dispatch<React.SetStateAction<any>>
    setFooterButtons: React.Dispatch<React.SetStateAction<any>>
    thisQuestion: ObjectStringKeyAnyValue
}

function QuestionSignature({
    answerPhoto,
    setAnswerPhoto,
    setFooterButtons,
    thisQuestion
}: Props) {

    const {
        tableData
    } = useContext(GlobalContext)

    useEffect(() => {
        if (answerPhoto) {
            setFooterButtons(['saveWithNote', 'save'])
        } else {
            if (thisQuestion && thisQuestion.isAnswerRequired === false) {
                setFooterButtons(['skip', 'back'])
            }
            else {
                setFooterButtons(['back'])
            }
        }
    }, [answerPhoto])


    return <div className={`w-full`}>
        <SignatureCanvas
            setSignatureCanvasData={setAnswerPhoto}
        />
    </div>
}
export default QuestionSignature